var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      ref: "button",
      class: [
        "btn-classic",
        ..._vm.variantClassList,
        _vm.disabled && "is-disabled",
        _vm.selected && "is-selected",
        _vm.disabled
          ? "is-disabled"
          : _vm.isLoading
          ? "is-disabled"
          : _vm.hasLoaded
          ? "is-disabled"
          : "",
        _vm.isLoading && "is-loading",
        _vm.hasLoaded && "has-loaded"
      ],
      attrs: {
        title: _vm.title,
        disabled: _vm.disabled,
        type: _vm.type,
        "aria-label": _vm.ariaLabel
      },
      on: {
        click: _vm.onClick,
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _vm.iconLeading
        ? _c("span", { staticClass: "btn-classic__icon-before" }, [
            _c("i", { class: ["icon", _vm.iconLeadingClassName] })
          ])
        : _vm._e(),
      _vm._t("default", function() {
        return [
          _vm.labelText
            ? _c("span", { staticClass: "btn-classic__label" }, [
                _vm._v(_vm._s(_vm.labelText))
              ])
            : _vm._e()
        ]
      }),
      _vm.iconTrailing
        ? _c("span", { staticClass: "btn-classic__icon-after" }, [
            _c("i", { class: ["icon", _vm.iconTrailingClassName] })
          ])
        : _vm._e(),
      _c("ButtonProgress", {
        attrs: {
          isLoading: _vm.isLoading,
          hasLoaded: _vm.hasLoaded,
          hasError: _vm.hasError,
          errorMessage: _vm.errorMessage
        }
      }),
      _c(
        "Tooltip",
        {
          attrs: {
            trackedRefName: "button",
            visible: _vm.validationToolipVisible,
            placement: "top",
            positionStrategy: "fixed",
            state: _vm.validationTooltipState
          }
        },
        [_vm._v(" " + _vm._s(_vm.validationMessage) + " ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }